import React, { useState } from "react";
import { Title, Meta } from "react-head";
import { motion } from "motion/react";
import { useSearchParams } from "react-router-dom";
import { FiSearch } from "react-icons/fi";

import WallpaperCatBar from "../components/Client/WallpaperCatBar";
import WallpaperGrid from "../components/Client/WallpaperGrid";
import ClientAdSense from "../components/Client/ClientAdSense";
import FixedButton from "../components/Client/FixedButton";
import WallpaperFooter from "../components/Client/WallpaperFooter";

const ClientWallpaperSearch = () => {
    const [params] = useSearchParams();
    const q = (params.get("q") || "").trim();
    const [total, setTotal] = useState(0);

    return (
        <div className='min-h-screen dm-sans client-home-bg'>
            <Title>{q ? `Search "${q}"` : "Search"} | PicPromptify Wallpapers</Title>
            <Meta name='description' content={`Search HD wallpapers on PicPromptify.`} />

            {/* top bar opens in search mode with the current query */}
            <WallpaperCatBar activeSlug='' initialQuery={q} />
            <FixedButton />

            <section className='relative w-full px-4 sm:px-6 md:px-8 pt-5 md:pt-7 pb-12 md:pb-20'>
                <div className='mx-auto max-w-7xl'>
                    {/* top banner ad */}
                    <ClientAdSense
                        slot='9729451986'
                        containerClassName='w-full mb-5 md:mb-7'
                    />

                    {q ? (
                        <>
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                className='flex items-center justify-between gap-3 mb-5 md:mb-7'
                            >
                                <div className='flex items-center gap-2 min-w-0'>
                                    <div
                                        className='w-1 h-6 rounded-full flex-shrink-0'
                                        style={{
                                            background:
                                                "linear-gradient(180deg, #7F00FF, #FCFA02)",
                                        }}
                                    />
                                    <h1 className='text-client-font font-semibold text-sm md:text-lg tracking-wide truncate'>
                                        Results for “{q}”
                                    </h1>
                                </div>
                                {total > 0 && (
                                    <div className='ios-glass px-3 py-1 rounded-full text-client-font/75 text-[10px] md:text-xs flex-shrink-0'>
                                        <span className='tabular-nums font-bold text-client-title'>
                                            {total}
                                        </span>{" "}
                                        found
                                    </div>
                                )}
                            </motion.div>

                            {/* key={q} → fresh search per query */}
                            <WallpaperGrid
                                key={q}
                                slug=''
                                search={q}
                                onMeta={(r) => setTotal(r?.totalRecords || 0)}
                                emptyTitle='No results'
                                emptyText={`No wallpapers match “${q}”. Try a different keyword.`}
                            />
                        </>
                    ) : (
                        /* no query yet */
                        <motion.div
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            className='flex flex-col items-center justify-center text-center py-20 md:py-28'
                        >
                            <div
                                className='w-16 h-16 md:w-20 md:h-20 rounded-2xl flex items-center justify-center mb-5'
                                style={{
                                    background:
                                        "linear-gradient(135deg, rgba(127,0,255,0.25), rgba(252,250,2,0.08))",
                                    border: "1px solid rgba(255,255,255,0.12)",
                                }}
                            >
                                <FiSearch className='text-2xl md:text-3xl text-client-title' />
                            </div>
                            <h1 className='text-client-font font-bold text-lg md:text-2xl tracking-tight'>
                                Search wallpapers
                            </h1>
                            <p className='text-client-font/55 text-sm md:text-base mt-2 max-w-md'>
                                Tap the search icon in the bar above and type a
                                keyword to find wallpapers.
                            </p>
                        </motion.div>
                    )}
                </div>
            </section>

            <WallpaperFooter />
        </div>
    );
};

export default ClientWallpaperSearch;
